module.exports = __webpack_public_path__ + "media/images/extension-onboarding/arrow-right-up-052bb59ce0e95a3255235bb725178c21.png";